export const T = {
  en_GB: {
    name: "Name",
    country: "Country",
    representativeSection: "Representative",
    representativeChecked: "— checked for PEP and sanctions",
    representativeRequired: "The representative's name and national ID are required.",
    registeredRepresentative:
      "Registered representative: screened as on record. Edit them under Related parties.",
    removeRepresentative: "Remove",
    fullName: "Full name",
  },
  nb_NO: {
    name: "Navn",
    country: "Land",
    representativeSection: "Representant",
    representativeChecked: "— sjekkes for PEP og sanksjoner",
    representativeRequired: "Representantens navn og fødselsnummer er påkrevd.",
    registeredRepresentative:
      "Registrert representant: screenes slik de står i registeret. Rediger dem under Relaterte parter.",
    removeRepresentative: "Fjern",
    fullName: "Fullt navn",
  },
} as const;
